
<ng-container *ngIf="!loading else loadingContainer">
  <div class="showingsContainer" [ngClass]="{'mobileShowingContainer': isMobile}">
    <ng-container *ngIf="showingData.length > 0 else noData">
      <showingItem 
        class="showingItem" 
        *ngFor="let item of showingData" 
        [showingData]="item" 
        [userData]="userData"
        [isMobile]="isMobile"
        [ngClass]="{'mobileShowingItem': isMobile}"
        (refrashList)="refrashList()"
      ></showingItem>
    </ng-container>
    
  </div>
</ng-container>




<ng-template  #loadingContainer>
  <div class="spinnerBox">
    <home365-loader [white]="false" [size]="'xxl'"></home365-loader>
  </div>
</ng-template> 


<ng-template  #noData>
  <div class="loadingContainer noShowing" [ngClass]="{'no_showing_mobile': isMobile}">
   <img src="./assets/img/noShowings.svg" alt="">
   <div class="noShowingText" *ngIf="!isMobile">
     {{'MY_SHOWINGS.NO_SHOWINGS_TEXT' | translate}}
   </div>
   <div class="noShowingText" *ngIf="isMobile">
      {{'MY_SHOWINGS.MOBILE_NO_SHOWINGS_TEXT' | translate}}
   </div>
  </div>
</ng-template> 

